<template>
  <div>
    <b-table-simple class="export-table" borderless outlined>
      <b-thead>
        <b-tr class="title-row">
          <b-th>{{ lodash.startCase($t('sale_notes.resumes.note')) }}</b-th>
        </b-tr>
      </b-thead>
      <b-tbody>
        <b-tr>
          <b-td v-html="value"></b-td>
        </b-tr>
      </b-tbody>
    </b-table-simple>
  </div>
</template>

<script>
export default {
  name: 'note-export',
  props: {
    value: {type: String, default: '-'},
  },
}
</script>

<style scoped>

</style>